import { ContextModalProps } from "@mantine/modals";

import { ExpeditionsQueueStatusAttendedModal } from "./ExpeditionsQueueStatusAttendedModal";
import { ExpeditionsQueueStatusDropoutModal } from "./ExpeditionsQueueStatusDropoutModal";
import { ExpeditionsQueueStatusMissingModal } from "./ExpeditionsQueueStatusMissingModal";

export type ExpeditionsQueueStatusModalProps = {
  type: "attended" | "missing" | "dropout";
  title: string;
};

function ExpeditionsQueueStatusScheduledModal(_props: ContextModalProps) {
  return (
    <div>
      <p>Content</p>
    </div>
  );
}

function ExpeditionsQueueStatusCourtyardModal(_props: ContextModalProps) {
  return (
    <div>
      <p>Content</p>
    </div>
  );
}

function ExpeditionsQueueStatusTonsModal(_props: ContextModalProps) {
  return (
    <div>
      <p>Content</p>
    </div>
  );
}

export const ExpeditionsQueueStatus = {
  scheduled: ExpeditionsQueueStatusScheduledModal,
  courtyard: ExpeditionsQueueStatusCourtyardModal,
  tons: ExpeditionsQueueStatusTonsModal,

  attended: ExpeditionsQueueStatusAttendedModal,
  missing: ExpeditionsQueueStatusMissingModal,
  dropout: ExpeditionsQueueStatusDropoutModal
} as const;
